/**
 * 柱状分布图数据处理模块
 */
import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const barDistributionValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: ['string', 'date'], required: true },
    { field: 'y', type: 'number', required: true }
  ],
  businessRules: [
    {
      name: 'bar-distribution-children-structure',
      validator: data => {
        // 检查每条数据是否包含children数组
        return data.every(item => {
          if (!Array.isArray(item.children)) {
            return false;
          }

          // 检查children中的每个元素是否包含name和value属性
          return item.children.every(
            (child: ChildItem) => typeof child.name === 'string' && typeof +child.value === 'number'
          );
        });
      },
      message: 'Bar distribution chart requires each data item to have a valid "children" array',
      suggestion:
        'Ensure each data item has a "children" array with objects containing "name" (string) and "value" (number) properties',
      // 关键数据结构错误，影响图表渲染
      severity: 'error'
    },
    {
      name: 'bar-distribution-sufficient-data',
      validator: data => data.length >= 2,
      message: 'Bar distribution chart requires at least 2 data points to show distribution',
      suggestion: 'Provide at least 2 data points to demonstrate distribution patterns',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'bar-distribution-optimal-data-count',
      validator: data => data.length <= 10,
      message: 'Bar distribution chart works best with 10 or fewer data points',
      suggestion: 'Consider limiting data to 10 points or using aggregation for better readability',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'bar-distribution-children-completeness',
      validator: data => {
        // 检查children数组是否有足够的子项
        return data.every(item => {
          if (!Array.isArray(item.children)) {
            // 其他规则会处理这个
            return true;
          }
          return item.children.length >= 1;
        });
      },
      message: 'Bar distribution chart requires non-empty children arrays',
      suggestion: 'Ensure each data item has at least one child element in the children array',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
